import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';

/** Creates code verifier */
export function createCodeVerifier(): string {
  return randomString(32);
}

/** Creates code challenge from code verifier  */
export function createCodeChallenge(codeVerifier: string): string {
  const hash = sha256Base64(codeVerifier);
  return urlEncodeB64(hash);
}

export function getToken(token: string) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export function randomString(length: number): string {
  const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let array = new Uint8Array(length);

  if (array.length === 0) {
    // @ts-ignore
    return undefined;
  }

  window.crypto.getRandomValues(array);
  array = array.map((x) => validChars.charCodeAt(x % validChars.length));
  return String.fromCharCode(...array);
}

export function urlEncodeB64(input: string) {
  const b64Chars = { '+': '-', '/': '_', '=': '' };
  // @ts-ignore
  return input.replace(/[\+\/=]/g, (m) => b64Chars[m]);
}

/** Returns the sha256 digest of a given message in base64 */
export function sha256Base64(message: string): string {
  return Base64.stringify(sha256(message));
}
